import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1032"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6.268 1.046c-2.901 0-5.257 2.518-5.257 5.661 0 3.142 2.356 5.621 5.257 5.621s5.266-2.478 5.266-5.621c0-3.142-2.365-5.661-5.266-5.661zm0 9.847c-2.11 0-3.821-1.834-3.821-4.185 0-2.352 1.712-4.226 3.821-4.226s3.83 1.874 3.83 4.226c.001 2.351-1.72 4.185-3.83 4.185zm8.045 1.021c.594-.445.719-1.25.499-1.842a1.642 1.642 0 0 0-1.602-1.031 1.726 1.726 0 0 0-1.423.901 1.653 1.653 0 0 0-.186.644h.838c.01-.038.128-.499.568-.643a.828.828 0 0 1 .676.044.778.778 0 0 1 .403.759c-.038.432-.646.852-1.534.808v.743c.93-.089 1.59.439 1.614.927.019.389-.359.922-.887.926-.379.003-.736-.263-.871-.662h-.838c.015.127.094.698.597 1.117.438.364.92.382 1.059.385.144.003.768 0 1.268-.494.078-.077.532-.554.509-1.296-.026-.83-.612-1.228-.69-1.286z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }